import { render, staticRenderFns } from "./ModalTableSsc.vue?vue&type=template&id=bea8b74c&"
import script from "./ModalTableSsc.vue?vue&type=script&lang=js&"
export * from "./ModalTableSsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports